import { render, staticRenderFns } from "./ModalUnpublish.vue?vue&type=template&id=951a00f4&scoped=true&"
import script from "./ModalUnpublish.vue?vue&type=script&lang=js&"
export * from "./ModalUnpublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951a00f4",
  null
  
)

export default component.exports